import React from 'react';
import PropTypes from 'prop-types';

import FullLogo from 'assets/golfDigest/branding-logos/full-logo.svg';

const BrandLogo = ({ type, className }) => {
  let Component = null;
  switch (type) {
    case 'standard':
      Component = FullLogo;
      break;
    default:
      Component = FullLogo;
  }

  return <Component className={className} />;
};

BrandLogo.defaultProps = {
  type: 'standard',
  className: '',
};

BrandLogo.propTypes = {
  type: PropTypes.string,
  className: PropTypes.string,
};

export default BrandLogo;
